export const thuocTinh = {
  sections: {
    list: { title: '商品属性' },
    detail: { title: '属性' },
    giaTri: { title: '属性值' },
  },
  titles: { add: '新增属性', edit: '编辑属性', create: '创建属性' },
  columns: {
    code: '编码',
    summary: '属性名称',
    note: '描述',
    loaiInput: '输入类型',
    moTa: '描述',
    status: '状态',
    soGiaTri: '值数量',
    soHangHoa: '商品数',
    nguoiTao: '创建人',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    onOffAction: '启停',
  },
  filter: {
    searchPlaceholder: '按编码 / 名称搜索...',
    textDetailTitle: '详细筛选',
  },
  filters: {
    hintSection: '提示',
    hintBody: '管理商品属性（颜色、尺码、容量等）。',
    statusAll: '全部状态',
    loaiInputAll: '全部类型',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  loaiInput: {
    text: '自由输入',
    select: '下拉选择',
    number: '数字',
  },
  actions: {
    pause: '停用',
    activate: '启用',
    addGiaTri: '添加值',
    editGiaTri: '编辑值',
    xoaGiaTri: '删除值',
    quanLyGiaTri: '管理值',
  },
  messages: {
    loadError: '无法加载属性列表。',
    deleteSuccess: '已删除属性。',
    noData: '暂无属性。',
    listSummary: '共 {count} 项',
    saveSuccess: '已保存属性。',
    statusChanged: '已更新状态。',
    createSuccess: '创建属性成功',
    selectedCount: '已选 {count}',
    deleteSelected: '删除已选（{count}）',
    bulkDeleteConfirm: '删除已选的 {count} 个属性？',
    bulkDeleteSuccess: '已删除 {count} 个属性',
    bulkDeletePartial: '已删除 {ok}/{total}。{failed} 个失败。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '尚未选择任何属性',
    hhCount: '{count} 商品',
    gtCount: '{count} 值',
    giaTriSaveSuccess: '已保存属性值。',
    giaTriDeleteSuccess: '已删除属性值。',
    giaTriNoData: '暂无值。请添加第一个值。',
    giaTriTrung: '该值已在列表中。',
    giaTriHintAdd: '保存属性后，您可以添加值（红色、L码...）。',
    giaTriInUse: '该值被 {count} 个商品使用，无法删除。',
  },
  form: {
    ten: '属性名称',
    maThuocTinh: '属性编码',
    moTa: '描述',
    loaiInput: '输入类型',
    thuTu: '排序',
    giaTri: '值',
  },
  validation: {
    tenRequired: '请输入属性名称。',
    giaTriRequired: '请输入值。',
  },
  placeholders: {
    formTitle: '属性',
    formBody: '',
    ten: '输入属性名称（如：颜色）',
    maThuocTinh: '留空则自动生成',
    nhapGiaTri: '输入值后按回车（如：红色、蓝色...）',
  },
  dropdown: {
    empty: '— 选择属性 —',
    giaTriEmpty: '— 选择值 —',
  },
}
